import { useEffect, useState } from 'react';
import { SparkleIcon } from '@phosphor-icons/react';

interface SuggestionCaptionProps {
  /** A suggestion request is inflight. */
  loading: boolean;
  /** A suggestion was applied and at least one suggested field still stands. */
  applied: boolean;
}

// Fast responses (cache hits land in ~100ms) shouldn't flash a loading line;
// only show it once the wait is actually noticeable.
const LOADING_GRACE_MS = 300;

/**
 * Attribution line for the AI category suggestion. The height is always
 * reserved so state flips never shift the form; suggestions themselves stay
 * non-blocking (the user can keep typing or save at any point).
 */
export function SuggestionCaption({ loading, applied }: SuggestionCaptionProps) {
  const [pastGrace, setPastGrace] = useState(false);

  useEffect(() => {
    if (!loading) {
      setPastGrace(false);
      return;
    }
    const timer = setTimeout(() => setPastGrace(true), LOADING_GRACE_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  return (
    <p
      role="status"
      aria-live="polite"
      className="flex h-4 items-center gap-1 text-2xs text-text-tertiary"
    >
      {loading && pastGrace ? (
        <>
          <SparkleIcon aria-hidden weight="fill" className="size-3 animate-pulse text-accent-brand" />
          Link está sugerindo…
        </>
      ) : applied ? (
        <>
          <SparkleIcon aria-hidden weight="fill" className="size-3 text-accent-brand" />
          Sugerido pelo Link
        </>
      ) : null}
    </p>
  );
}
